<template>
  <div class="news">
    <banner title="新闻资讯" subtitle="NEWS & INSIGHTS" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2"
          >
            <span>行业动态</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="$img(item.Img)"></div>
            <p class="item-list-title">{{item.Title}}</p>
            <p class="item-list-content">{{item.Content}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.Id }}"
              >
                <span>阅读更多</span>
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
          </div>
          <div v-if="!loading && !newsList.length" class="empty-tip">暂无相关资讯</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`News/Search?type=${this.newstype}&count=9`)
        .then(response => {
          this.newsList = response.data || [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);

  &-section {
    width: 100%;
    padding-bottom: 40px;

    &-content {
      width: 1240px;
      max-width: calc(100% - 32px);
      margin: -28px auto 0;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
      padding: 0 24px 40px;
      position: relative;
      z-index: 1;

      .content-nav {
        width: 360px;
        height: 48px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        top: -24px;
        border-radius: 999px;
        overflow: hidden;
        box-shadow: 0 8px 20px rgba(20, 103, 159, 0.18);

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eef4f9;
          color: #4d6b82;
          cursor: pointer;
          transition: all 0.25s ease;
          font-size: 15px;
        }

        .content-nav-active {
          background: linear-gradient(90deg, #1f6fab, #3aa0d8);
          color: #fff;
        }
      }

      .content-nav-item {
        width: 100%;
        margin: 8px auto 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 18px;

        .item-list {
          width: calc(33.333% - 12px);
          min-width: 300px;
          display: flex;
          flex-direction: column;
          padding: 16px;
          border: 1px solid #e6eef5;
          border-radius: 12px;
          background: #fff;
          transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

          &:hover {
            transform: translateY(-4px);
            border-color: #c9deee;
            box-shadow: 0 12px 28px rgba(20, 103, 159, 0.12);
          }

          .item-img {
            width: 100%;
            height: 190px;
            border-radius: 10px;
            background-color: #e8eef4;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
          }

          &-title {
            margin: 16px 0 10px;
            color: #17324a;
            font-size: 18px;
            line-height: 1.4;
            height: 50px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          &-content {
            height: 72px;
            font-size: 14px;
            color: #6b8296;
            line-height: 1.7;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          &-more {
            margin-top: 16px;
            .text-decoration {
              text-decoration: none;
              color: #1f6fab;
              font-size: 14px;
              display: inline-flex;
              align-items: center;
              gap: 4px;
            }
          }
        }

        .empty-tip {
          width: 100%;
          text-align: center;
          color: #7a93a8;
          padding: 60px 0;
        }
      }
    }
  }
}

@media (max-width: 1100px) {
  .news-section-content .content-nav-item .item-list {
    width: calc(50% - 9px);
    min-width: 0;
  }
}

@media (max-width: 720px) {
  .news-section-content {
    padding: 0 14px 28px;
  }

  .news-section-content .content-nav {
    width: min(360px, 100%);
  }

  .news-section-content .content-nav-item {
    gap: 12px;
  }

  .news-section-content .content-nav-item .item-list {
    width: 100%;
  }
}
</style>
